import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class TalepEdenTransferService {
	private talepEdenSource = new BehaviorSubject<{
		txtTalepEdenDistKod: number | null;
	}>({
		txtTalepEdenDistKod: null
	});

	talepEden$ = this.talepEdenSource.asObservable();

	setTalepEden(data: { txtTalepEdenDistKod: number }) {
		this.talepEdenSource.next(data);
	}

	getTalepEden() {
		return this.talepEdenSource.getValue();
	}

	clear() {
		this.talepEdenSource.next({
			txtTalepEdenDistKod: null
		});
	}
}
